function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none",
  opacity: 0.35
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#000",
  width: 50,
  height: 82,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.235 28.813l2.855 2.843-7.341 7.313H38v4.062H19.749l7.341 7.313-2.855 2.843L12 41z",
  fill: "#FFF"
}));

function SvgGalleryArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 82",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGalleryArrowLeft;